import { useEffect } from 'react'
import {
  Route,
  Switch,
  useHistory,
  useRouteMatch,
  useLocation,
} from 'react-router-dom'
import { Container, rawBreakpoints } from '@redriverpress/system'

import useIncludedMediaQuery from 'Common/hooks/useIncludedMediaQuery'

import {
  setIsSmallBreakpoint,
  setSocialSso,
  useStudentOnboardingContext,
} from './context/onboardingStudentContext'
import {
  ChoosePath,
  CreatePassword,
  EnterClassCode,
  SignIn,
  SignUp,
  Summary,
  TermsAndConditions,
  WhatIsYourEmail,
  WhatIsYourName,
} from './pages'
import OnboardingNavBar from './common/components/OnboardingNavBar'
import FlashMessage from './common/components/FlashMessage'
import Stepper from './common/components/Stepper'
import { STD_ONBOARDING_PATH } from './common/constants'

export default function SignUpManager() {
  const history = useHistory()
  const { pathname } = useLocation()

  const matchRoot = useRouteMatch({
    path: STD_ONBOARDING_PATH.root,
    exact: true,
  })
  const matchSignup = useRouteMatch({
    path: STD_ONBOARDING_PATH.signup,
    exact: true,
  })
  const matchLogin = useRouteMatch({
    path: STD_ONBOARDING_PATH.login,
  })
  const matchTerms = useRouteMatch({
    path: `${STD_ONBOARDING_PATH.signup}/terms-and-conditions`,
  })

  const { maxBreakpoint } = useIncludedMediaQuery(rawBreakpoints.sm)
  const isSm = maxBreakpoint

  const [
    { cleverSsoUrl, googleSsoUrl, socialSso, currentStep },
    dispatch,
  ] = useStudentOnboardingContext()

  useEffect(() => {
    if (googleSsoUrl.includes('redirect_to_sign_up') && !currentStep) {
      dispatch(setSocialSso('google'))
      history.push({
        pathname: `${STD_ONBOARDING_PATH.signup}`,
      })
    }

    if (cleverSsoUrl.includes('redirect_to_sign_up') && !currentStep) {
      dispatch(setSocialSso('clever'))
      history.push({
        pathname: `${STD_ONBOARDING_PATH.signup}`,
      })
    }

    if (!matchRoot && !matchSignup && !matchLogin && !currentStep) {
      history.push({ pathname: STD_ONBOARDING_PATH.root })
    }
  }, [pathname])

  useEffect(() => {
    dispatch(setIsSmallBreakpoint(isSm))
  }, [maxBreakpoint])

  const shouldShowStepper =
    !socialSso && !matchRoot && !matchLogin && !matchSignup && !matchTerms

  return (
    <>
      <OnboardingNavBar />
      <Container my={0} minHeight='90vh'>
        <Switch>
          <Route path='/' exact>
            <ChoosePath />
          </Route>
          <Route path={STD_ONBOARDING_PATH.login}>
            <SignIn />
          </Route>
          <Route path={STD_ONBOARDING_PATH.signup} exact>
            <SignUp />
          </Route>
          <Route path={`${STD_ONBOARDING_PATH.signup}/enter-class-code`}>
            <EnterClassCode />
          </Route>
          <Route path={`${STD_ONBOARDING_PATH.signup}/what-is-your-name`}>
            <WhatIsYourName />
          </Route>
          <Route path={`${STD_ONBOARDING_PATH.signup}/what-is-your-email`}>
            <WhatIsYourEmail />
          </Route>
          <Route path={`${STD_ONBOARDING_PATH.signup}/create-password`}>
            <CreatePassword />
          </Route>
          <Route path={`${STD_ONBOARDING_PATH.signup}/terms-and-conditions`}>
            <TermsAndConditions />
          </Route>
          <Route path={`${STD_ONBOARDING_PATH.signup}/summary`}>
            <Summary />
          </Route>
        </Switch>
        {shouldShowStepper && <Stepper />}
        <FlashMessage />
      </Container>
    </>
  )
}
